var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5784 13.4162L4.36351 0.41048C2.63981 -0.645727 0 0.379231 0 2.99163V28.9968C0 31.3405 2.45297 32.7529 4.36351 31.578L25.5784 18.5785C27.4709 17.4223 27.4769 14.5724 25.5784 13.4162Z",
    fill: "url(#paint0_radial_211_585)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_211_585",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.32143 10) rotate(66.6875) scale(49.5448 98.6252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.444736cd919cffcc3757d72829c28eb3.svg";
export { ForwardRef as ReactComponent };